import script from "./CareerGraduates.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerGraduates.vue?vue&type=script&setup=true&lang=js"

import "./CareerGraduates.vue?vue&type=style&index=0&id=0dd05f0c&lang=scss"

const __exports__ = script;

export default __exports__